import { Base } from './base.model';
export class PasswordReset {
  public username = new Base();
  public valid = true;

  public resetCustomErrors(): void {
    this.username.errorMessage = '';
  }
}
